import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { MuiTextField, MuiSelect, AccordionWithArrow, MessageReactQuery } from '../../../../components'
import ForumService from '../../../../services/forum.service'
import { useReactQuery } from '../../../../hooks/useReactQuery'
import { defaultSelectObj } from '../../../../util'
import { GridContainer } from './style'

const UserProperties = ({ data, mode, onChange, expanded }) => {
  const [formExpanded, setFormExpanded] = useState(expanded)
  const modeType = mode === 'none'
  const birthYearToAgeFunc = (year) => {
    const d = new Date()
    return (d.getFullYear() - year) + ''
  }

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: ['CountryList'],
      urlFunc: ForumService.getCountriesApi,
      payload: {}
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const useReactQueryObject2 = {
    payloadDetails: {
      queryId: ['StateList'],
      urlFunc: ForumService.getStatesApi,
      payload: {}
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const { data: data1, isLoading: isLoading1, isSuccess: isSuccess1, isError: isError1, error: error1 } = useReactQuery(useReactQueryObject1)
  const { data: data2, isLoading: isLoading2, isSuccess: isSuccess2, isError: isError2, error: error2 } = useReactQuery(useReactQueryObject2)

  const [formSectionData, setFormSectionData] = useState({
    InfluenceLevel: data?.InfluenceLevel || null,
    InfluenceType: data?.InfluenceType || null,
    UserName: data?.UserName || null,
    UserUrl: data?.UserUrl || null,
    Gender: data?.Gender || null,
    Age: data?.BirthYear ? birthYearToAgeFunc(data?.BirthYear) : null,
    BirthYear: data?.BirthYear || null,
    RelationStatus: data?.RelationStatus || null,
    Country: data?.Country || null,
    State: data?.State || null,
    City: data?.City || null,
    ProcessStep: data?.ProcessStep || null
  })

  const [formSelectData, setFormSelectData] = useState({
    influenceType: [],
    processStep: [],
    gender: [],
    relationStatus: [],
    country: [],
    state: []
  })

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formSectionData,
      [key]: value
    }
    if (key === 'Age') {
      const d = new Date()
      obj.BirthYear = (d.getFullYear() - value) + ''
    }
    setFormSectionData(obj)
    onChange(obj)
  }

  /*
  const loadCountryData = () => {
    ForumService.getCountriesApi({})
      .then((resp) => {
        setFormSelectData({ ...formSelectData, country: resp.map(d => ({ label: d, value: d })) })
      })
      .catch((error) => {
        consoleLog('ERROR : ', error)
      })
  }

  const loadStateData = () => {
    ForumService.getStatesApi({})
      .then((resp) => {
        setFormSelectData({ ...formSelectData, state: resp.map(d => ({ label: d, value: d })) })
      })
      .catch((error) => {
        consoleLog('ERROR : ', error)
      })
  }
  */

  const onLoad = () => {
    // if (formSelectData.country.length === 0) loadCountryData()
    // if (formSelectData.state.length === 0) loadStateData()
    if (formSelectData.influenceType.length === 0) {
      const influenceTypeArray = [defaultSelectObj.empty, { label: 'Institution', value: '0' }, { label: 'Individual', value: '1' }, { label: '', value: '2' }]
      const processStepArray = (data.CheckedBy !== 'NONE')
        ? [{ value: null, label: '' }, { value: 'QC', label: 'QC' }, { value: 'Reanalyze', label: 'Reanalyze' }]
        : [{ value: null, label: '' }, { value: 'Analyze', label: 'Analyze' }, { value: 'QC', label: 'QC' }]
      // : [{ value: null, label: '' }, { value: 'Analyze', label: 'Analyze' }, { value: 'QC', label: 'QC' }, { value: 'Reanalyze', label: 'Reanalyze' }]
      const gender = [defaultSelectObj.empty, { label: 'Male', value: 'Male' }, { label: 'Female', value: 'Female' }, { label: '', value: '2' }]
      const relationStatus = [defaultSelectObj.empty, { label: 'Single', value: 'Single' }, { label: 'Married', value: 'Married' }, { label: 'Divorced', value: 'Divorced' }, { label: 'Committed', value: 'Committed' }, { label: '', value: '4' }]
      // const education = [defaultSelectObj.empty, { label: 'School: 9 years', value: '0' }, { label: 'SSC/HSC', value: '1' }, { label: 'College (not graduate)', value: '2' }, { label: 'Graduate', value: '3' }, { label: 'Post Graduate', value: '4' }, { label: '', value: '5' }]
      // const occupation = [defaultSelectObj.empty, { label: 'Self Employed', value: '0' }, { label: 'Working Professional', value: '1' }, { label: 'Housewife', value: '2' }, { label: 'Student', value: '3' }, { label: 'Retired', value: '4' }, { label: 'Unemployed', value: '5' }, { label: '', value: '6' }]

      setFormSelectData({
        ...formSelectData,
        processStep: processStepArray,
        influenceType: influenceTypeArray,
        gender,
        relationStatus
        // education,
        // occupation
      })
    }
    if (formSelectData.influenceType.length !== 0) {
      onChangeHandler('UserUrl', formSectionData?.UserUrl)
    }

    let processSteps = ''
    if (data.CheckedBy === 'NONE') {
      processSteps = 'Analyze'
    } else if (data.ProcessStep === 'Analyze') {
      processSteps = 'QC'
    } else if (data.ProcessStep === 'QC') {
      processSteps = 'QC'
    } else if (data.ProcessStep === 'Reanalyze') {
      processSteps = 'QC'
    }

    setFormSectionData(prev => ({ ...prev, ProcessStep: processSteps }))
  }

  const hasDataAndNotDisabled = (value) => {
    if (isNaN(value)) { return true }
    if (modeType) { return ((value)?.length > 0) && modeType }
    return true
  }

  useEffect(() => {
    onLoad()
  }, [formSelectData])

  useEffect(() => {
    if (formSectionData) {
      onChange(formSectionData)
    }
  }, [formSectionData])

  useEffect(() => {
    setFormExpanded(expanded)
  }, [expanded])

  useEffect(() => {
    const processSteps = (data.CheckedBy === 'NONE') ? 'Analyze' : 'QC'
    setFormSectionData(prev => ({ ...prev, ProcessStep: processSteps }))
  }, [mode])

  const onSuccess1Func = (resp) => {
    setFormSelectData(prev => ({ ...prev, country: resp.map(d => ({ label: d, value: d })) }))
  }
  useEffect(() => {
    if (isSuccess1 && data1?.length) onSuccess1Func(data1)
  }, [isSuccess1, data1])

  const onSuccess2Func = (resp) => {
    setFormSelectData(prev => ({ ...prev, state: resp.map(d => ({ label: d, value: d })) }))
  }
  useEffect(() => {
    if (isSuccess2 && data2?.length) onSuccess2Func(data2)
  }, [isSuccess2, data2])

  return (
    <>
      <MessageReactQuery
        isLoading={isLoading1 || isLoading2}
        isSuccess={isSuccess1 || isSuccess2}
        data={data1 || data2}
        isError={isError1 || isError2}
        error={error1 || error2}
      />
      <GridContainer container spacing={2}>
        {hasDataAndNotDisabled(formSectionData?.InfluenceLevel) && <Grid item xs={4}>
          <MuiTextField
            name='InfluenceLevel'
            // label='Index'
            placeholder='Index'
            onChange={(e) => onChangeHandler('InfluenceLevel', e.target.value)}
            variant='standard'
            value={formSectionData?.InfluenceLevel || ''}
            disabled={true}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.ProcessStep) && mode === 'process' && <Grid item xs={4}>
          <MuiSelect
            data={formSelectData.processStep}
            name='ProcessStep'
            // label='Process Step'
            placeholder='Process Step'
            onChange={(e) => onChangeHandler('ProcessStep', e.target.value)}
            variant='standard'
            value={formSectionData?.ProcessStep}
            defaultValue={formSectionData?.ProcessStep}
          />
        </Grid>}
      </GridContainer>

      <AccordionWithArrow title='User Properties' expanded={formExpanded} accordionstyle='fieldset' showOverlay={mode === 'none'}>
        <Grid container spacing={2}>
          {hasDataAndNotDisabled(formSectionData?.InfluenceType) && formSelectData.influenceType && <Grid item xs={4}>
            <MuiSelect
              data={formSelectData.influenceType}
              name='influenceType'
              // label='Influence Type'
              placeholder='Influence Type'
              onChange={(e) => onChangeHandler('InfluenceType', e.target.value)}
              variant='standard'
              value={formSectionData?.InfluenceType}
              disabled={modeType}
            />
          </Grid>}
          {hasDataAndNotDisabled(formSectionData?.UserName) && <Grid item xs={4}>
            <MuiTextField
              name='userName'
              // label='User Name'
              placeholder='User Name'
              onChange={(e) => onChangeHandler('UserName', e.target.value)}
              variant='standard'
              value={formSectionData?.UserName || ''}
              disabled={modeType}
            />
          </Grid>}
          {hasDataAndNotDisabled(formSectionData?.UserUrl) && <Grid item xs={4}>
            <MuiTextField
              name='userUrl'
              // label='User Url'
              placeholder='User Url'
              onChange={(e) => onChangeHandler('UserUrl', e.target.value)}
              variant='standard'
              value={formSectionData?.UserUrl || ''}
              disabled={modeType}
            />
          </Grid>}
          {hasDataAndNotDisabled(formSectionData?.Gender) && <Grid item xs={4}>
            <MuiSelect
              data={formSelectData.gender}
              name='gender'
              // label='Gender'
              placeholder='Gender'
              onChange={(e) => onChangeHandler('Gender', e.target.value)}
              variant='standard'
              value={formSectionData?.Gender || ''}
              disabled={modeType}
            />
          </Grid>}
          {hasDataAndNotDisabled(formSectionData?.Age) && <Grid item xs={4}>
            <MuiTextField
              name='age'
              // label='Age'
              placeholder='Age'
              onChange={(e) => onChangeHandler('Age', e.target.value)}
              variant='standard'
              type='number'
              value={formSectionData?.Age || ''}
              disabled={modeType}
            />
          </Grid>}
          {/* {hasDataAndNotDisabled(formSectionData?.BirthYear) && <Grid item xs={4}>
            <MuiTextField
              name='BirthYear'
              // label='BirthYear'
              placeholder='BirthYear'
              onChange={(e) => onChangeHandler('BirthYear', e.target.value)}
              variant='standard'
              type='number'
              value={formSectionData?.BirthYear || ''}
              disabled={modeType}
            />
          </Grid>} */}
          {hasDataAndNotDisabled(formSectionData?.RelationStatus) && <Grid item xs={4}>
            <MuiSelect
              data={formSelectData.relationStatus}
              name='relationStatus'
              // label='Relation Status'
              placeholder='Relation Status'
              onChange={(e) => onChangeHandler('RelationStatus', e.target.value)}
              variant='standard'
              value={formSectionData?.RelationStatus || ''}
              disabled={modeType}
            />
          </Grid>}
          {hasDataAndNotDisabled(formSectionData?.Country) && formSelectData.country.length > 0 && <Grid item xs={4}>
            <MuiSelect
              data={formSelectData.country}
              name='country'
              // label='Country'
              placeholder='Country'
              onChange={(e) => onChangeHandler('Country', e.target.value)}
              variant='standard'
              value={formSectionData?.Country || ''}
              disabled={modeType}
            />
          </Grid>}
          {hasDataAndNotDisabled(formSectionData?.State) && formSelectData.state.length > 0 && <Grid item xs={4}>
            <MuiSelect
              data={formSelectData.state}
              name='state'
              // label='State'
              placeholder='State'
              onChange={(e) => onChangeHandler('State', e.target.value)}
              variant='standard'
              value={formSectionData?.State || ''}
              disabled={modeType}
            />
          </Grid>}
          {hasDataAndNotDisabled(formSectionData?.City) && <Grid item xs={4}>
            <MuiTextField
                name='city'
                // label='City'
                placeholder='City'
                onChange={(e) => onChangeHandler('City', e.target.value)}
                variant='standard'
                value={formSectionData?.City || ''}
                disabled={modeType}
              />
          </Grid>}
        </Grid>
      </AccordionWithArrow>
    </>
  )
}

UserProperties.propTypes = {
  data: PropTypes.object,
  mode: PropTypes.string,
  onChange: PropTypes.func,
  expanded: PropTypes.bool
}

export default UserProperties
